import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Link } from '../../components/Link';
import { reloadPage } from '../../Utils/reload';

/**
 * Snackbar-innehåll när GET /estates/permissions felar eller tar för lång
 * tid. Portalen öppnas då med basbehörigheterna, och användaren ska förstå
 * varför fastighetsrapporterna saknas i menyn i stället för att tro att de
 * är borttagna.
 */
const PermissionsFallbackMessage = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <strong>{t('permissions_fallback_title')}</strong>
      <span>{t('permissions_fallback_text')}</span>
      <Link as="button" type="button" onClick={reloadPage}>
        {t('permissions_fallback_action')}
      </Link>
    </Wrapper>
  );
};

export default PermissionsFallbackMessage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
`;
